import css from './Valid.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import bwipjs from '@bwip-js/browser'
import QRCode from 'qrcode.react'
import { GoodTicketCode } from 'types/tickets'

import { IGoodServiceTicketData } from 'meta/pages/goodsandservices'
import { Dates } from 'utils/dates'

import { ButtonRed } from 'components/Actions/Action'

interface Props {
  data: IGoodServiceTicketData
  showTap2GoModal(show: boolean): void
}

const Valid: React.FC<Props> = (props) => {
  const { data, showTap2GoModal } = props

  const { t } = useTranslation()

  const areGatesAlreadyOpen = Dates.isAfter(new Date(), new Date(data.openDateEvent_tz))

  const isTicketDrink = data?.event?.policy?.code == GoodTicketCode.drink

  return (
    <div className={css.wrapper}>
      {data.hasVaultEnabled ? (
        <>
          <div className={css.qr}>
            <div className={css.scan_text}>
              {t(isTicketDrink ? 'goodsAndServices:scan_code_drink' : 'goodsAndServices:scan_code_generic')}
            </div>
            <div className={css.qrCode_img}>
              <canvas
                ref={(canvas) => {
                  if (!canvas) {
                    return
                  }

                  bwipjs.toCanvas(canvas, {
                    bcid: 'datamatrixrectangular', // Barcode type
                    text: data.secret, // Text to encode
                    width: 35,
                    height: 15,
                  })
                }}
              />
            </div>
          </div>

          <div className={css.separator}>
            <span className={css.or}>{t('goodsAndServices:or')}</span>
          </div>

          <div className={css.use_drink}>
            <div className={css.use_drink_description}>{t('goodsAndServices:press_button')}</div>
            <ButtonRed
              className={css.use_drink_button}
              disabled={!areGatesAlreadyOpen}
              onClick={() => {
                showTap2GoModal(true)
              }}
            >
              {t('goodsAndServices:button_base_use_drink')}
            </ButtonRed>
          </div>
        </>
      ) : (
        <>
          <div className={css.dataVaultDisabled}>
            <div className={css.qr}>
              <QRCode value={data.secret} size={188} />
            </div>
            <div className={css.scan_text}>
              {t(isTicketDrink ? 'goodsAndServices:scan_code_drink' : 'goodsAndServices:scan_code_generic')}
            </div>
          </div>
        </>
      )}

      <div className={css.bottom_label}>
        <div className={css.status}>
          {t(isTicketDrink ? `goodsAndServices:status_usable_drink` : `goodsAndServices:status_usable_generic`)}
        </div>
        <div className={css.datetime}>
          {Dates.format(new Date(data.validFrom), t('goodsAndServices:status_valid_datetime'))}
        </div>
      </div>
    </div>
  )
}

export default Valid
